import React from 'react';

const Research = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col justify-center items-center p-8">
      <h1 className="text-3xl font-bold mb-8 text-center">Explore the Latest Research</h1>
      <p className="text-lg text-gray-700 max-w-lg mb-8">
        Dive into the latest research and insights on entrepreneurship, innovation, and the startup ecosystem. Our platform provides access to in-depth studies, whitepapers, and articles authored by leading experts in the field, including Dr. Prakash Sharma. Explore the Passion Framework's seven dimensions and 28 process areas, uncovering valuable strategies for building successful startups, fostering industry-academic collaborations, and leveraging emerging technologies like Artificial Intelligence and Robotic Process Automation.
      </p>
    </div>
  );
};

export default Research;
